import { render, staticRenderFns } from "./ReviewNovikov.vue?vue&type=template&id=0242b316&scoped=true&"
var script = {}
import style0 from "./ReviewNovikov.vue?vue&type=style&index=0&id=0242b316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242b316",
  null
  
)

export default component.exports